import { BerlinThemeProvider } from "@src/appV2/redesign/theme/ThemeProvider";

import { MobileAddVisitWizardContainer } from "./MobileAddVisitWizardContainer";

export function MobileAddVisitWizardPage() {
  return (
    <BerlinThemeProvider fullHeight>
      <MobileAddVisitWizardContainer />
    </BerlinThemeProvider>
  );
}
